import { useSelectedApp } from './../../../hooks/creation/adgroup/useSelectedApp/index';
import { AdgroupFormData, CampaignFormData, IOS14Type } from '@tt4b/ttam-enums';
import { useAllowlist, useSplitTestEnabled } from '@tt4b/ttam-hooks';
import { computed, ref, Ref } from '@vue/composition-api';

export function usePropsVisible(options: { adgroupData: Ref<AdgroupFormData> }) {
  const { adgroupData } = options;
  const { isFrozenApp } = useSelectedApp({
    adgroupData,
  });
  // Todo Splittest
  const isSplitTestEnabled = ref(false);
  const visible = computed(() => adgroupData.value.targetDeviceVersion === IOS14Type.ABOVE && !isFrozenApp.value);

  return {
    visible,
  };
}

export function usePropsSplitTestDetailVisible(options: {
  campaignData: Ref<CampaignFormData>;
  adgroupData: Ref<AdgroupFormData>;
}) {
  const { isSplitTestEnabled: splitTestDetailVisible } = useSplitTestEnabled(options);
  return {
    splitTestDetailVisible,
  };
}
